import {UserBlockReasonModificationDomain} from "../../domain/user/UserBlockReasonModificationDomain"

export const UserBlockReasonModificationDescriptor: Record<keyof UserBlockReasonModificationDomain, (o: UserBlockReasonModificationDomain) => string> = {
    id(o: UserBlockReasonModificationDomain): string {
        return o.id.toString()
    },
    creatorId(o: UserBlockReasonModificationDomain): string {
        return o.creatorId.toString()
    },
    userBlockReasonId(o: UserBlockReasonModificationDomain): string {
        return o.userBlockReasonId.toString()
    },
    body(o: UserBlockReasonModificationDomain): string {
        return o.body
    },
    createdAt(o: UserBlockReasonModificationDomain): string {
        return o.createdAt.toISOString().substring(0, 19).replace('T', ' ')
    }
}
